import { render } from "./RecoveryPage.vue?vue&type=template&id=6da53604"
import script from "./RecoveryPage.vue?vue&type=script&lang=js"
export * from "./RecoveryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__